import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import MuiAlert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function SuccessAlert() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.success);

  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.success(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="success"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.success(false))}
        >
          Data added successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

function DeleteFailureAlert() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const deleteFailure = useSelector((state) => state.sidebar.delete_failure);

  return (
    <div>
      <Snackbar
        open={deleteFailure}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.delete_failure(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.delete_failure(false))}
        >
          Company has dependency.Cannot delete this company.
        </Alert>
      </Snackbar>
    </div>
  );
}

function FailureAlert() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Failure = useSelector((state) => state.sidebar.failure);

  return (
    <div>
      <Snackbar
        open={Failure}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.failure(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.failure(false))}
        >
          Oops!! Try again.
        </Alert>
      </Snackbar>
    </div>
  );
}

function InformationAlert() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Information = useSelector((state) => state.sidebar.information);

  return (
    <div>
      <Snackbar
        open={Information}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.information(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="warning"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.information(false))}
        >
          This Data is already present!!
        </Alert>
      </Snackbar>
    </div>
  );
}

function SuccessUpdate() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.update_success);

  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.update_success(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="success"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.update_success(false))}
        >
          Data updated successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

function FailureUpdate() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.update_failure);

  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.update_failure(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.update_failure(false))}
        >
          Data updated unscuessfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

function SuccessDelete() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.delete_success);
  // console.log("Successfull",useSelector((state) => state.sidebar))
  // console.log("Success",Success)
  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.delete_success(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="success"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.delete_success(false))}
        >
          Data deleted successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}
function SuccessPassword() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.success);

  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.success(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="success"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.success(false))}
        >
          Password updated successfully!
        </Alert>
      </Snackbar>
    </div>
  );
}

function FailurePassword() {
  const dispatch = useDispatch();
  const vertical = useSelector((state) => state.sidebar.top);
  const horizontal = useSelector((state) => state.sidebar.center);
  const Success = useSelector((state) => state.sidebar.update_failure);

  return (
    <div>
      <Snackbar
        open={Success}
        autoHideDuration={2000}
        onClose={() => dispatch(sidebarReducer.update_failure(false))}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%" }}
          onClose={() => dispatch(sidebarReducer.update_failure(false))}
        >
          Failed!
        </Alert>
      </Snackbar>
    </div>
  );
}

export {
  SuccessAlert,
  FailureAlert,
  DeleteFailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
  SuccessPassword,
  FailurePassword
};
